import { buildDemoSprites, defaultHud } from "./pixelArt";
import { resolveThemeBackground } from "./themeBackgrounds";

export const STATUSES = [
  { id: "approved", label: "Terminada", color: "#4ade80" },
  { id: "thinking", label: "En progreso", color: "#fbbf24" },
  { id: "review", label: "Por mejorar", color: "#fb9f7a" },
  { id: "neutral", label: "Borrador", color: "#c4b5c8" },
  { id: "cut", label: "Descartada", color: "#f9a8d4" },
];

export const IDEA_LINK_ROLES = [
  { id: "weapon", label: "Arma" },
  { id: "scene", label: "Escenario" },
  { id: "ally", label: "Aliado" },
  { id: "enemy", label: "Enemigo" },
  { id: "item", label: "Objeto" },
  { id: "skill", label: "Habilidad" },
  { id: "related", label: "Relacionado" },
];

export const STATUS_MAP = Object.fromEntries(STATUSES.map((s) => [s.id, s]));

export const DEFAULT_MODULES = [
  { id: "characters", name: "Personajes", enabled: true, color: "#3B82F6", icon: "User" },
  { id: "npcs", name: "NPCs", enabled: true, color: "#8B5CF6", icon: "Users" },
  { id: "mobs", name: "Mobs", enabled: true, color: "#F59E0B", icon: "Bug" },
  { id: "enemies", name: "Enemigos", enabled: true, color: "#EF4444", icon: "Skull" },
  { id: "minibosses", name: "Semiboses", enabled: true, color: "#F97316", icon: "Shield" },
  { id: "bosses", name: "Bosses", enabled: true, color: "#DC2626", icon: "Crown" },
  { id: "items", name: "Items/Objetos", enabled: true, color: "#10B981", icon: "Cube" },
  { id: "articles", name: "Artículos", enabled: true, color: "#14B8A6", icon: "Package" },
  { id: "weapons", name: "Armas", enabled: true, color: "#EAB308", icon: "Sword" },
  { id: "armor", name: "Armaduras", enabled: true, color: "#6366F1", icon: "ShieldCheck" },
];

export const STORY_TYPES = [
  { id: "chapter", name: "Historia principal", color: "#4c7dff" },
  { id: "mission", name: "Misiones", color: "#8b5cf6" },
  { id: "secret", name: "Secretos", color: "#f59e0b" },
  { id: "objective", name: "Objetivos", color: "#10b981" },
  { id: "faction", name: "Facciones", color: "#ec4899" },
  { id: "place", name: "Lugares clave", color: "#14b8a6" },
];

export const DEFAULT_KANBAN = {
  columns: [
    { id: "todo", title: "Por Hacer", cards: [] },
    { id: "doing", title: "En Progreso", cards: [] },
    { id: "done", title: "Hecho", cards: [] },
  ],
};

export const GENRES_2D = [
  "Platformer", "Action-Adventure", "RPG", "Metroidvania", "Shooter",
  "Puzzle", "Roguelike", "Beat 'em up", "Visual Novel",
  "Tower Defense", "Racing", "Sandbox", "Stealth",
];

export const ENGINES_2D = ["GameCraft 2D", "Phaser", "Godot", "Unity 2D", "GameMaker", "Pygame", "Custom"];

export const PROJECT_SKINS = [
  { id: "aurora", group: "Estudio", name: "Pergamino", desc: "Crema, lila y terracota", primary: "#c45c4a", accent2: "#a881af", banner: "linear-gradient(135deg,#c45c4a 0%,#9b3d4a 55%,#7a2e4a 100%)", bg: "#f3ebe3", darkBg: "#0c0618", tool: "#12081c", glow: "rgba(196,92,74,.28)", pattern: "radial-gradient(900px 420px at 8% -8%, rgba(168,129,175,.22), transparent 55%), radial-gradient(700px 380px at 100% 0%, rgba(196,92,74,.12), transparent 50%)" },
  { id: "void", group: "Estudio", name: "Vacío", desc: "Cian de mazmorra", primary: "#22d3ee", accent2: "#6366f1", banner: "linear-gradient(135deg,#0ea5e9,#6366f1)", bg: "#e8f4f8", darkBg: "#020617", tool: "#020617", glow: "rgba(34,211,238,.22)", pattern: "linear-gradient(180deg, rgba(14,165,233,.08), transparent 40%)" },
  { id: "ink", group: "Estudio", name: "Tinta", desc: "Alto contraste", primary: "#64748b", accent2: "#e2e8f0", banner: "linear-gradient(135deg,#334155,#0f172a 70%,#1e293b)", bg: "#f8fafc", darkBg: "#020617", tool: "#000000", glow: "rgba(148,163,184,.2)", pattern: "repeating-linear-gradient(90deg, transparent, transparent 24px, rgba(15,23,42,.04) 24px 25px)" },
  { id: "forest", group: "Mundos", name: "Bosque", desc: "Dosel, musgo y claros", primary: "#34d399", accent2: "#a3e635", banner: "linear-gradient(160deg,#14532d 0%,#166534 45%,#4d7c0f 100%)", bg: "#ecfdf5", darkBg: "#022c22", tool: "#052e16", glow: "rgba(52,211,153,.25)", pattern: "radial-gradient(ellipse 80% 50% at 20% 110%, rgba(34,197,94,.28), transparent), radial-gradient(ellipse 60% 40% at 90% -10%, rgba(132,204,22,.16), transparent)" },
  { id: "space", group: "Mundos", name: "Espacio", desc: "Nebulosa y estrellas", primary: "#818cf8", accent2: "#22d3ee", banner: "linear-gradient(145deg,#020617 0%,#1e1b4b 40%,#4c1d95 75%,#0ea5e9 130%)", bg: "#eef2ff", darkBg: "#020617", tool: "#0b1020", glow: "rgba(129,140,248,.3)", pattern: "radial-gradient(1.5px 1.5px at 12% 18%, rgba(255,255,255,.55), transparent), radial-gradient(1px 1px at 38% 62%, rgba(165,180,252,.7), transparent), radial-gradient(1.5px 1.5px at 72% 28%, rgba(34,211,238,.5), transparent), radial-gradient(1px 1px at 88% 78%, rgba(255,255,255,.4), transparent), radial-gradient(ellipse at 70% 20%, rgba(124,58,237,.22), transparent 50%)" },
  { id: "medieval", group: "Mundos", name: "Medieval", desc: "Piedra, oro y tapiz", primary: "#d4a017", accent2: "#7f1d1d", banner: "linear-gradient(160deg,#3f2a14 0%,#7f1d1d 42%,#b45309 78%,#eab308 100%)", bg: "#faf6ee", darkBg: "#1c1410", tool: "#1a120c", glow: "rgba(212,160,23,.28)", pattern: "repeating-linear-gradient(45deg, transparent, transparent 14px, rgba(120,53,15,.07) 14px 15px), radial-gradient(ellipse at 50% 0%, rgba(185,28,28,.16), transparent 55%)" },
  { id: "ocean", group: "Mundos", name: "Océano", desc: "Olas y abismo", primary: "#22d3ee", accent2: "#0369a1", banner: "linear-gradient(180deg,#082f49 0%,#0e7490 55%,#67e8f9 100%)", bg: "#ecfeff", darkBg: "#042f2e", tool: "#083344", glow: "rgba(6,182,212,.28)", pattern: "radial-gradient(ellipse 120% 60% at 50% 120%, rgba(6,182,212,.28), transparent), repeating-linear-gradient(-12deg, transparent, transparent 28px, rgba(8,47,73,.06) 28px 30px)" },
  { id: "desert", group: "Mundos", name: "Desierto", desc: "Dunas al atardecer", primary: "#f59e0b", accent2: "#ea580c", banner: "linear-gradient(135deg,#78350f 0%,#c2410c 40%,#f59e0b 75%,#fde68a 100%)", bg: "#fff7ed", darkBg: "#1c1008", tool: "#1c140a", glow: "rgba(245,158,11,.3)", pattern: "radial-gradient(ellipse at 80% 120%, rgba(234,88,12,.2), transparent 50%), radial-gradient(ellipse at 10% 0%, rgba(253,224,71,.18), transparent 45%)" },
  { id: "volcano", group: "Mundos", name: "Volcán", desc: "Magma y ceniza", primary: "#f43f5e", accent2: "#fb923c", banner: "linear-gradient(160deg,#1c0a0a 0%,#7f1d1d 38%,#ea580c 72%,#fbbf24 100%)", bg: "#fff1f2", darkBg: "#1a0505", tool: "#140404", glow: "rgba(244,63,94,.32)", pattern: "radial-gradient(ellipse at 50% 110%, rgba(234,88,12,.35), transparent 55%), radial-gradient(circle at 20% 20%, rgba(251,191,36,.12), transparent 35%)" },
  { id: "tundra", group: "Mundos", name: "Tundra", desc: "Hielo y aurora", primary: "#67e8f9", accent2: "#a5b4fc", banner: "linear-gradient(160deg,#0f172a 0%,#164e63 50%,#67e8f9 85%,#e0f2fe 100%)", bg: "#f0f9ff", darkBg: "#082f49", tool: "#0b1c2c", glow: "rgba(103,232,249,.28)", pattern: "linear-gradient(180deg, rgba(224,242,254,.2), transparent 40%), radial-gradient(ellipse at 80% 0%, rgba(167,139,250,.18), transparent 50%)" },
  { id: "neon", group: "Mundos", name: "Neón", desc: "Ciudad cyberpunk", primary: "#f472b6", accent2: "#22d3ee", banner: "linear-gradient(120deg,#4a044e 0%,#86198f 40%,#db2777 70%,#22d3ee 120%)", bg: "#fdf4ff", darkBg: "#19010f", tool: "#12010c", glow: "rgba(244,114,182,.32)", pattern: "repeating-linear-gradient(90deg, transparent, transparent 40px, rgba(34,211,238,.07) 40px 41px), radial-gradient(ellipse at 0% 100%, rgba(219,39,119,.22), transparent 50%)" },
  { id: "sakura", group: "Mundos", name: "Sakura", desc: "Pétalos y papel", primary: "#fb7185", accent2: "#f9a8d4", banner: "linear-gradient(135deg,#9f1239 0%,#fb7185 45%,#fecdd3 80%,#fff1f2 100%)", bg: "#fff1f2", darkBg: "#1f0a14", tool: "#1a0810", glow: "rgba(251,113,133,.28)", pattern: "radial-gradient(circle at 15% 20%, rgba(251,113,133,.2) 0 8px, transparent 9px), radial-gradient(circle at 70% 80%, rgba(253,164,175,.18) 0 12px, transparent 13px)" },
  { id: "swamp", group: "Mundos", name: "Pantano", desc: "Niebla y veneno", primary: "#84cc16", accent2: "#65a30d", banner: "linear-gradient(160deg,#1a2e05 0%,#3f6212 50%,#65a30d 100%)", bg: "#f7fee7", darkBg: "#0f1a05", tool: "#10180a", glow: "rgba(132,204,22,.22)", pattern: "radial-gradient(ellipse at 40% 90%, rgba(101,163,13,.25), transparent 50%), radial-gradient(ellipse at 90% 10%, rgba(15,23,42,.2), transparent 40%)" },
  { id: "arcade", group: "Mundos", name: "Arcade", desc: "CRT y scanlines", primary: "#facc15", accent2: "#22c55e", banner: "linear-gradient(90deg,#14532d 0%,#166534 30%,#eab308 70%,#f97316 100%)", bg: "#fefce8", darkBg: "#052e16", tool: "#022c22", glow: "rgba(250,204,21,.28)", pattern: "repeating-linear-gradient(0deg, transparent, transparent 3px, rgba(0,0,0,.08) 3px 4px)" },
  { id: "scroll", group: "Mundos", name: "Pergamino", desc: "Tinta y pergamino", primary: "#b45309", accent2: "#44403c", banner: "linear-gradient(135deg,#44403c 0%,#78716c 35%,#d6d3d1 70%,#fef3c7 100%)", bg: "#fafaf9", darkBg: "#1c1917", tool: "#1c1917", glow: "rgba(180,83,9,.2)", pattern: "repeating-linear-gradient(0deg, transparent, transparent 22px, rgba(120,113,108,.08) 22px 23px)" },
  { id: "abyss", group: "Mundos", name: "Abismo", desc: "Fosa oceánica", primary: "#2dd4bf", accent2: "#6366f1", banner: "linear-gradient(180deg,#020617 0%,#042f2e 40%,#134e4a 70%,#2dd4bf 110%)", bg: "#f0fdfa", darkBg: "#01040c", tool: "#020617", glow: "rgba(45,212,191,.25)", pattern: "radial-gradient(ellipse at 50% 0%, rgba(99,102,241,.18), transparent 45%), radial-gradient(ellipse at 30% 100%, rgba(13,148,136,.22), transparent 50%)" },
  { id: "steam", group: "Mundos", name: "Steampunk", desc: "Cobre y engranajes", primary: "#d97706", accent2: "#78716c", banner: "linear-gradient(135deg,#1c1917 0%,#78350f 40%,#b45309 70%,#fbbf24 100%)", bg: "#fafaf9", darkBg: "#1c1410", tool: "#171412", glow: "rgba(217,119,6,.28)", pattern: "repeating-conic-gradient(from 30deg at 90% 10%, transparent 0 20deg, rgba(180,83,9,.08) 0 22deg)" },
  { id: "farm", group: "Mundos", name: "Pradera", desc: "Granja y cielo", primary: "#84cc16", accent2: "#38bdf8", banner: "linear-gradient(180deg,#38bdf8 0%,#7dd3fc 28%,#86efac 55%,#65a30d 100%)", bg: "#f0fdf4", darkBg: "#14532d", tool: "#052e16", glow: "rgba(132,204,22,.22)", pattern: "linear-gradient(180deg, rgba(56,189,248,.2) 0 28%, transparent 28%), repeating-linear-gradient(90deg, transparent, transparent 18px, rgba(101,163,13,.08) 18px 19px)" },
  { id: "ember", group: "Estudio", name: "Brasa", desc: "Lava y oro", primary: "#f97316", accent2: "#ef4444", banner: "linear-gradient(135deg,#f97316,#ef4444 70%)", bg: "#fff4eb", darkBg: "#1a0b08", tool: "#1c0f0a", glow: "rgba(249,115,22,.28)", pattern: "radial-gradient(ellipse at 50% 100%, rgba(239,68,68,.2), transparent 50%)" },
  { id: "moss", group: "Estudio", name: "Musgo", desc: "Bosque clásico", primary: "#10b981", accent2: "#0d9488", banner: "linear-gradient(135deg,#34d399,#0d9488)", bg: "#ecfdf5", darkBg: "#052e16", tool: "#052e16", glow: "rgba(16,185,129,.22)", pattern: "radial-gradient(ellipse at 0% 100%, rgba(13,148,136,.18), transparent 50%)" },
  { id: "orchid", group: "Estudio", name: "Orquídea", desc: "Magia", primary: "#a855f7", accent2: "#ec4899", banner: "linear-gradient(135deg,#c084fc,#ec4899)", bg: "#faf5ff", darkBg: "#1a0b2e", tool: "#1e1033", glow: "rgba(168,85,247,.28)", pattern: "radial-gradient(ellipse at 90% 0%, rgba(236,72,153,.18), transparent 50%)" },
];

export const SKIN_GROUPS = [...new Set(PROJECT_SKINS.map((s) => s.group))];

export function skinToConfig(skin, extra = {}) {
  const s = typeof skin === "string" ? PROJECT_SKINS.find((x) => x.id === skin) : skin;
  if (!s) return extra;
  return {
    skin: s.id,
    accent: s.primary,
    accent2: s.accent2,
    banner: s.banner,
    bg: s.bg,
    tool_bg: s.tool,
    pattern: s.pattern,
    glow: s.glow,
    palette: SKIN_PALETTES[s.id] || extra.palette,
    bg_preset: extra.bg_source === "custom" ? extra.bg_preset : s.id,
    bg_source: extra.bg_source === "custom" ? "custom" : "preset",
    ...extra,
  };
}

export const CAMERA_MODES = [
  {
    id: "side",
    name: "Lado a lado",
    tag: "Metal Slug",
    hint: "Plataformas, gravedad y salto. Run & gun / beat 'em up de lado.",
    gravity: 600,
  },
  {
    id: "topdown",
    name: "Cámara de arriba",
    tag: "Enter the Gungeon",
    hint: "Vista cenital, 8 direcciones, sin gravedad. Twin-stick / dungeon crawler.",
    gravity: 0,
  },
];

export const DEFAULT_THEME_APPLY = {
  background: true,
  containers: true,
  highlights: true,
  text: true,
  buttons: true,
  banners: true,
};

export const SKIN_PALETTES = {
  aurora: ["#c45c4a", "#a881af", "#e8dff5", "#2a1f1c", "#fffdfb"],
  forest: ["#14532d", "#166534", "#4d7c0f", "#a3e635", "#052e16"],
  space: ["#020617", "#1e1b4b", "#4c1d95", "#818cf8", "#22d3ee"],
  medieval: ["#3f2a14", "#7f1d1d", "#b45309", "#eab308", "#faf6ee"],
  ocean: ["#082f49", "#0e7490", "#22d3ee", "#67e8f9", "#ecfeff"],
  desert: ["#78350f", "#c2410c", "#f59e0b", "#fde68a", "#fff7ed"],
  volcano: ["#1c0a0a", "#7f1d1d", "#ea580c", "#fbbf24", "#fff1f2"],
  tundra: ["#0f172a", "#164e63", "#67e8f9", "#a5b4fc", "#e0f2fe"],
  neon: ["#4a044e", "#db2777", "#f472b6", "#22d3ee", "#fdf4ff"],
  sakura: ["#9f1239", "#fb7185", "#fecdd3", "#fff1f2", "#1f0a14"],
  swamp: ["#1a2e05", "#3f6212", "#84cc16", "#f7fee7", "#0f1a05"],
  arcade: ["#14532d", "#eab308", "#22c55e", "#f97316", "#fefce8"],
  scroll: ["#44403c", "#b45309", "#d6d3d1", "#fef3c7", "#1c1917"],
  abyss: ["#020617", "#134e4a", "#2dd4bf", "#6366f1", "#f0fdfa"],
  steam: ["#1c1917", "#78350f", "#d97706", "#fbbf24", "#fafaf9"],
  farm: ["#14532d", "#65a30d", "#86efac", "#38bdf8", "#f0fdf4"],
  void: ["#020617", "#0ea5e9", "#22d3ee", "#6366f1", "#e8f4f8"],
  ember: ["#1a0b08", "#f97316", "#ef4444", "#fbbf24", "#fff4eb"],
  moss: ["#052e16", "#10b981", "#34d399", "#0d9488", "#ecfdf5"],
  orchid: ["#1a0b2e", "#a855f7", "#c084fc", "#ec4899", "#faf5ff"],
  ink: ["#020617", "#334155", "#64748b", "#e2e8f0", "#f8fafc"],
};

export const DEFAULT_SCENES = [
  { id: "boot", name: "Boot" },
  { id: "menu", name: "Menú" },
  { id: "level1", name: "Nivel 1" },
  { id: "gameover", name: "Game Over" },
];

export const DEFAULT_MILESTONES = [
  { id: "vs60", title: "Vertical slice de 60s (entrar → conflicto → premio)", done: false },
  { id: "enemy", title: "Un enemigo con telegráfo", done: false },
  { id: "loop", title: "Loop de 20s estable", done: false },
  { id: "audio", title: "SFX de salto + hit + recoger", done: false },
];

export const DEFAULT_SHIP = [
  { id: "controls", title: "Controles responden", done: false },
  { id: "death", title: "Muerte y restart", done: false },
  { id: "volume", title: "Volumen / mute", done: false },
  { id: "credits", title: "Créditos CC de assets", done: false },
];

export function worldTilesetPng(skinId, size = 16) {
  const pal = SKIN_PALETTES[skinId] || SKIN_PALETTES.forest;
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext("2d");
  ctx.imageSmoothingEnabled = false;
  for (let y = 0; y < size; y++) {
    for (let x = 0; x < size; x++) {
      const edge = x === 0 || y === 0 || x === size - 1 || y === size - 1;
      const i = edge ? 0 : (x + y * 3) % (pal.length - 1);
      ctx.fillStyle = pal[edge ? 0 : i + 1] || pal[0];
      ctx.fillRect(x, y, 1, 1);
    }
  }
  return canvas.toDataURL("image/png");
}

export function dataUrlToPixelGrid(dataUrl, grid) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      const c = document.createElement("canvas");
      c.width = grid;
      c.height = grid;
      const ctx = c.getContext("2d");
      ctx.imageSmoothingEnabled = false;
      ctx.clearRect(0, 0, grid, grid);
      ctx.drawImage(img, 0, 0, grid, grid);
      const { data } = ctx.getImageData(0, 0, grid, grid);
      const pixels = [];
      for (let i = 0; i < data.length; i += 4) {
        if (data[i + 3] < 18) pixels.push(null);
        else {
          const hex = `#${[data[i], data[i + 1], data[i + 2]].map((n) => n.toString(16).padStart(2, "0")).join("")}`;
          pixels.push(hex);
        }
      }
      resolve(pixels);
    };
    img.onerror = reject;
    img.src = dataUrl;
  });
}

export function scalePixelGrid(pixels, from, to) {
  const next = Array(to * to).fill(null);
  if (!from || !to) return next;
  for (let y = 0; y < to; y++) {
    for (let x = 0; x < to; x++) {
      const sx = Math.min(from - 1, Math.floor((x + 0.5) * from / to));
      const sy = Math.min(from - 1, Math.floor((y + 0.5) * from / to));
      next[y * to + x] = pixels[sy * from + sx] ?? null;
    }
  }
  return next;
}

export function padPixelGrid(pixels, from, to) {
  const next = Array(to * to).fill(null);
  const copy = Math.min(from, to);
  for (let y = 0; y < copy; y++) {
    for (let x = 0; x < copy; x++) next[y * to + x] = pixels[y * from + x] ?? null;
  }
  return next;
}

export const STANDARD_PIXEL_SIZES = [8, 16, 24, 32, 48, 64, 96, 128, 256];

export function nearestCanvasSize(w, h, max = 128) {
  const m = Math.max(4, Math.min(max, Math.max(Number(w) || 32, Number(h) || 32)));
  return STANDARD_PIXEL_SIZES.reduce((best, s) => (Math.abs(s - m) < Math.abs(best - m) ? s : best), 32);
}

export function probeImageSize(dataUrl) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight });
    img.onerror = reject;
    img.src = dataUrl;
  });
}

export function quantizeToPalette(pixels, palette) {
  if (!palette?.length) return pixels;
  const rgb = palette.map((h) => {
    const n = parseInt(String(h).replace("#", ""), 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  });
  const near = (hex) => {
    const n = parseInt(String(hex).replace("#", ""), 16);
    const r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
    let best = palette[0], d = 1e9;
    rgb.forEach((c, i) => {
      const dd = (c[0] - r) ** 2 + (c[1] - g) ** 2 + (c[2] - b) ** 2;
      if (dd < d) { d = dd; best = palette[i]; }
    });
    return best;
  };
  return pixels.map((p) => (p ? near(p) : null));
}

export function assetFileName(kind, label, size) {
  const base = String(label || "sprite").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "").slice(0, 24) || "sprite";
  return `${kind || "sprite"}_${base}${size ? `_${size}` : ""}`;
}

export function computeDebt(project) {
  const ents = flattenEntities(project);
  const sprites = project.sprites || [];
  const samples = [...(project.samples || []), ...(project.soundboard || [])];
  const noSprite = ents.filter((e) => !e.linked_sprite_id && !sprites.some((s) => (s.name || "").toLowerCase().includes((e.name || "").toLowerCase().slice(0, 8))));
  const noAnim = (project.animations || []).length === 0;
  const noAudio = samples.length < 3;
  const untested = (project.kanban?.columns || []).find((c) => c.id === "todo")?.cards?.length || 0;
  return {
    noSprite,
    noAnim,
    noAudio,
    untested,
    total: noSprite.length + (noAnim ? 1 : 0) + (noAudio ? 1 : 0) + untested,
  };
}

export function debtKanbanCards(project) {
  const debt = computeDebt(project);
  return debt.noSprite.slice(0, 12).map((e) => ({
    id: crypto.randomUUID(),
    title: `Sprite para ${e.name || e.kind}`,
    tags: ["deuda", e.kind],
    status: "thinking",
    entityId: e.id,
  }));
}

/** Convierte el log de playtest en tarjetas de kanban (mecánicas rotas). */
export function playEventsToKanban(events = []) {
  const text = events.map((e) => (typeof e === "string" ? e : e.evt || e.note || "")).join("\n").toLowerCase();
  const cards = [];
  const add = (title, tags) => cards.push({ id: crypto.randomUUID(), title, tags, status: "thinking" });
  if (/inventario lleno/.test(text)) add("Inventario lleno en playtest — subir slots o bajar drops", ["playtest", "inventario"]);
  if ((text.match(/hazard hit|hurt|daño/g) || []).length >= 3) add("Demasiado daño de contacto — bajar HP enemigo o i-frames", ["playtest", "balance"]);
  if (/nada cerca/.test(text)) add("Pickup no alcanza — ampliar rango de E", ["playtest", "pickup"]);
  if (/puerta dummy/.test(text)) add("Puerta dummy: definir siguiente sala", ["playtest", "world"]);
  if (!/agarraste/.test(text) && /objetos en el suelo/.test(text)) add("Nadie recogió loot — tutorial de E", ["playtest"]);
  return cards;
}

export function recolorDataUrl(dataUrl, hueShift = 40) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const c = document.createElement("canvas");
      c.width = img.width;
      c.height = img.height;
      const ctx = c.getContext("2d");
      ctx.drawImage(img, 0, 0);
      const id = ctx.getImageData(0, 0, c.width, c.height);
      const d = id.data;
      for (let i = 0; i < d.length; i += 4) {
        if (d[i + 3] < 16) continue;
        const [h, s, l] = rgbToHsl(d[i], d[i + 1], d[i + 2]);
        const [r, g, b] = hslToRgb((h + hueShift) % 360, s, l);
        d[i] = r; d[i + 1] = g; d[i + 2] = b;
      }
      ctx.putImageData(id, 0, 0);
      resolve(c.toDataURL("image/png"));
    };
    img.src = dataUrl;
  });
}

function rgbToHsl(r, g, b) {
  r /= 255; g /= 255; b /= 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0, s = 0;
  const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
    h *= 60;
  }
  return [h, s, l];
}
function hslToRgb(h, s, l) {
  const a = s * Math.min(l, 1 - l);
  const f = (n) => {
    const k = (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };
  return [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
}

export function stitchAtlas(sprites, tile = 32) {
  const list = (sprites || []).slice(0, 64);
  const cols = Math.max(1, Math.ceil(Math.sqrt(list.length)));
  const rows = Math.ceil(list.length / cols) || 1;
  const c = document.createElement("canvas");
  c.width = cols * tile;
  c.height = rows * tile;
  const ctx = c.getContext("2d");
  ctx.imageSmoothingEnabled = false;
  return Promise.all(list.map((s) => new Promise((res) => {
    const img = new Image();
    img.onload = () => res(img);
    img.onerror = () => res(null);
    img.src = s.data_url;
  }))).then((imgs) => {
    imgs.forEach((img, i) => {
      if (!img) return;
      const x = (i % cols) * tile;
      const y = Math.floor(i / cols) * tile;
      ctx.drawImage(img, 0, 0, img.width, img.height, x, y, tile, tile);
    });
    return c.toDataURL("image/png");
  });
}

export function hexToRgba(hex, alpha = 0.12) {
  const h = String(hex || "#4c7dff").replace("#", "");
  const full = h.length === 3 ? h.split("").map((c) => c + c).join("") : h.padEnd(6, "0");
  const n = parseInt(full.slice(0, 6), 16);
  if (Number.isNaN(n)) return `rgba(76,125,255,${alpha})`;
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${alpha})`;
}

export function applyProjectSkin(config) {
  const root = document.documentElement;
  const keys = ["--gc-primary", "--gc-primary-soft", "--gc-banner", "--gc-bg", "--gc-tool", "--gc-bg-image", "--gc-pattern", "--gc-glow", "--gc-accent-2", "--gc-text", "--gc-muted"];
  const flags = ["background", "containers", "highlights", "text", "buttons", "banners"];
  if (!config) {
    keys.forEach((k) => root.style.removeProperty(k));
    flags.forEach((k) => root.removeAttribute(`data-gc-${k}`));
    return;
  }
  const skin = PROJECT_SKINS.find((s) => s.id === (config.skin || "aurora")) || PROJECT_SKINS[0];
  const dark = document.documentElement.getAttribute("data-theme") === "dark";
  const primary = config.accent || skin.primary;
  const bg = config.bg || (dark ? skin.darkBg : skin.bg);
  const apply = { ...DEFAULT_THEME_APPLY, ...(config.theme_apply || {}) };
  flags.forEach((k) => root.setAttribute(`data-gc-${k}`, apply[k] !== false ? "on" : "off"));
  root.style.setProperty("--gc-primary", primary);
  root.style.setProperty("--gc-primary-soft", hexToRgba(primary, 0.14));
  root.style.setProperty("--gc-banner", apply.banners === false
    ? (dark ? "linear-gradient(135deg,#1e293b,#0f172a)" : "linear-gradient(135deg,#64748b,#94a3b8)")
    : (config.banner || skin.banner));
  root.style.setProperty("--gc-bg", apply.background === false ? (dark ? "#0c0618" : "#f3ebe3") : bg);
  root.style.setProperty("--gc-tool", config.tool_bg || skin.tool);
  root.style.setProperty("--gc-pattern", apply.background === false ? "none" : (config.pattern || skin.pattern || "none"));
  root.style.setProperty("--gc-glow", config.glow || skin.glow || hexToRgba(primary, 0.22));
  root.style.setProperty("--gc-accent-2", config.accent2 || skin.accent2 || primary);
  if (apply.text !== false) {
    root.style.setProperty("--gc-text", dark ? "#f3e8ff" : "#2a1f1c");
    root.style.setProperty("--gc-muted", dark ? "#c4b5d6" : "#a881af");
  } else {
    root.style.removeProperty("--gc-text");
    root.style.removeProperty("--gc-muted");
  }
  const bgUrl = apply.background === false ? "" : resolveThemeBackground(config);
  if (bgUrl) {
    root.style.setProperty("--gc-bg-image", `url(${bgUrl})`);
  } else {
    root.style.removeProperty("--gc-bg-image");
  }
}

export const SPRITE_STUDIOS = [
  {
    id: "creatures",
    label: "Personajes & criaturas",
    hint: "Jugador, NPCs, mobs, enemigos, semiboses y bosses.",
    size: 32,
    ai: "pixel art 2D game character sprite, side view, transparent background, clean pixels",
    query: "pixel art 2d game character sprite hero",
    kinds: [
      { id: "character", label: "Personaje" },
      { id: "npc", label: "NPC" },
      { id: "mob", label: "Mob" },
      { id: "enemy", label: "Enemigo" },
      { id: "miniboss", label: "Semiboss" },
      { id: "boss", label: "Boss" },
    ],
    subtypes: [
      { id: "hero", label: "Héroe / MC" },
      { id: "npc", label: "NPC" },
      { id: "mob", label: "Mob" },
      { id: "creature", label: "Criatura" },
      { id: "enemy", label: "Enemigo" },
      { id: "miniboss", label: "Semiboss" },
      { id: "boss", label: "Boss" },
    ],
  },
  {
    id: "gear",
    label: "Objetos & equipo",
    hint: "Items, artículos, armas y armaduras.",
    size: 24,
    ai: "pixel art inventory icon, centered, transparent background, 2D game item",
    query: "pixel art 2d game item weapon icon",
    kinds: [
      { id: "weapon", label: "Arma" },
      { id: "armor", label: "Armadura" },
      { id: "item", label: "Item" },
      { id: "article", label: "Artículo" },
      { id: "icon", label: "Icono UI" },
    ],
    subtypes: [
      { id: "longsword", label: "Espada larga" },
      { id: "axe", label: "Hacha" },
      { id: "hammer", label: "Martillo" },
      { id: "bow", label: "Arco" },
      { id: "dagger", label: "Daga" },
      { id: "potion", label: "Poción" },
      { id: "rune", label: "Piedra rúnica" },
      { id: "key", label: "Llave" },
      { id: "armor", label: "Armadura" },
    ],
  },
  {
    id: "world",
    label: "Mapa, terreno & mundos",
    hint: "Tilesets, suelo, paredes, fondos, props y decoración.",
    size: 16,
    ai: "pixel art tileset tile, seamless terrain, 2D game map, top-down or side",
    query: "pixel art tileset terrain 2d game map",
    kinds: [
      { id: "tileset", label: "Tileset" },
      { id: "terrain", label: "Terreno" },
      { id: "background", label: "Fondo / parallax" },
      { id: "prop", label: "Prop / decoración" },
      { id: "building", label: "Edificio" },
    ],
    subtypes: [
      { id: "floor", label: "Suelo" },
      { id: "wall", label: "Pared" },
      { id: "door", label: "Puerta" },
      { id: "hazard", label: "Hazard" },
      { id: "deco", label: "Decoración" },
    ],
  },
  {
    id: "hud",
    label: "HUD & UI",
    hint: "Corazones, barras, retrato, score y slots. Se ve en el motor.",
    size: 32,
    ai: "pixel art game HUD icon, heart health bar UI, transparent background",
    query: "pixel art game hud ui heart health bar",
    kinds: [
      { id: "heart", label: "Corazón" },
      { id: "bar", label: "Barra" },
      { id: "portrait", label: "Retrato" },
      { id: "slot", label: "Slot" },
      { id: "frame", label: "Marco" },
      { id: "icon", label: "Icono HUD" },
    ],
    subtypes: [
      { id: "heart", label: "Corazón" },
      { id: "bar", label: "Barra" },
      { id: "portrait", label: "Retrato" },
      { id: "slot", label: "Slot" },
      { id: "buff", label: "Icono buff" },
    ],
  },
];

export const AUDIO_STUDIOS = [
  { id: "sfx", label: "SFX combate", hint: "Golpes, salto, roll, daño recibido.", query: "sfx", color: "#22d3ee", tags: ["jump", "hit", "hurt", "roll"] },
  { id: "foley", label: "SFX mundo", hint: "Recoger, tirar, usar, UI.", query: "foley", color: "#fbbf24", tags: ["pickup", "throw", "use", "ui"] },
  { id: "music", label: "Música", hint: "Temas, loops y pistas.", query: "music", color: "#a78bfa", tags: ["loop", "theme"] },
  { id: "ambient", label: "Ambiente", hint: "Cuevas, bosque, lluvia, mazmorra.", query: "ambient", color: "#34d399", tags: ["ambient"] },
  { id: "voice", label: "Voces", hint: "Gritos, diálogos, cries.", query: "voice", color: "#fb923c", tags: ["voice"] },
];

export const AUDIO_TAGS = [
  { id: "jump", label: "Salto" }, { id: "hit", label: "Golpe" }, { id: "hurt", label: "Daño" },
  { id: "roll", label: "Roll" }, { id: "pickup", label: "Recoger" }, { id: "throw", label: "Tirar" },
  { id: "use", label: "Usar" }, { id: "ui", label: "UI" }, { id: "loop", label: "Loop" }, { id: "voice", label: "Voz" },
];

export const IDEA_SUBTYPES = {
  characters: [{ id: "hero", label: "Héroe / MC" }, { id: "npc", label: "NPC" }],
  npcs: [{ id: "npc", label: "NPC" }, { id: "merchant", label: "Mercader" }],
  mobs: [{ id: "mob", label: "Mob" }, { id: "creature", label: "Criatura" }],
  enemies: [{ id: "enemy", label: "Enemigo" }, { id: "creature", label: "Criatura" }],
  minibosses: [{ id: "miniboss", label: "Semiboss" }],
  bosses: [{ id: "boss", label: "Boss" }],
  items: [{ id: "potion", label: "Poción" }, { id: "rune", label: "Piedra rúnica" }, { id: "key", label: "Llave" }],
  articles: [{ id: "rune", label: "Piedra rúnica" }, { id: "key", label: "Llave" }],
  weapons: [
    { id: "longsword", label: "Espada larga" }, { id: "axe", label: "Hacha" },
    { id: "hammer", label: "Martillo" }, { id: "bow", label: "Arco" }, { id: "dagger", label: "Daga" },
  ],
  armor: [{ id: "armor", label: "Armadura" }],
};

/** Campos de ficha. El esquema vive en cada submódulo (Personajes, Armas…), no en la idea. */
export const IDEA_FIELD_CATALOG = [
  { id: "name", label: "Nombre", type: "text", locked: true },
  { id: "role", label: "Rol / tipo", type: "text" },
  { id: "subtype", label: "Tipo concreto", type: "subtype" },
  { id: "subcategory", label: "Subcategoría", type: "subcategory" },
  { id: "status", label: "Estado", type: "status" },
  { id: "hp", label: "HP", type: "number" },
  { id: "damage", label: "Daño", type: "number" },
  { id: "defense", label: "Defensa", type: "number" },
  { id: "speed", label: "Velocidad", type: "number" },
  { id: "notes", label: "Notas", type: "textarea", wide: true },
  { id: "tags", label: "Etiquetas", type: "tags", wide: true },
];

export const IDEA_FIELD_MAP = Object.fromEntries(IDEA_FIELD_CATALOG.map((f) => [f.id, f]));

const COMBAT_FIELDS = ["name", "role", "subtype", "subcategory", "status", "hp", "damage", "defense", "speed", "notes", "tags"];
const GEAR_FIELDS = ["name", "role", "subtype", "subcategory", "status", "damage", "speed", "notes", "tags"];
const ITEM_FIELDS = ["name", "role", "subtype", "subcategory", "status", "notes", "tags"];
const ARMOR_FIELDS = ["name", "role", "subtype", "subcategory", "status", "defense", "hp", "notes", "tags"];

export const DEFAULT_MODULE_FIELDS = {
  characters: COMBAT_FIELDS,
  npcs: COMBAT_FIELDS,
  mobs: COMBAT_FIELDS,
  enemies: COMBAT_FIELDS,
  minibosses: COMBAT_FIELDS,
  bosses: COMBAT_FIELDS,
  items: ITEM_FIELDS,
  articles: ITEM_FIELDS,
  weapons: GEAR_FIELDS,
  armor: ARMOR_FIELDS,
};

export function defaultFieldsForModule(moduleId) {
  return [...(DEFAULT_MODULE_FIELDS[moduleId] || ITEM_FIELDS)];
}

export function resolveModuleFields(mod) {
  const raw = Array.isArray(mod?.fields) && mod.fields.length
    ? mod.fields
    : defaultFieldsForModule(mod?.id);
  return raw.map((entry) => {
    if (typeof entry === "string") {
      const cat = IDEA_FIELD_MAP[entry];
      return cat ? { ...cat } : { id: entry, label: entry, type: "text", custom: true };
    }
    const cat = IDEA_FIELD_MAP[entry.id];
    return { ...(cat || { type: "text", custom: true }), ...entry };
  });
}

export function serializeModuleFields(fields) {
  return (fields || []).map((f) => {
    if (f.custom || !IDEA_FIELD_MAP[f.id]) {
      return { id: f.id, label: f.label, type: f.type || "text", custom: true };
    }
    if (f.label && IDEA_FIELD_MAP[f.id].label !== f.label) return { id: f.id, label: f.label };
    return f.id;
  });
}

export const ENGINE_TEST_MODES = [
  { id: "all", label: "Todo el juego", hint: "Pisos, criaturas, loot, armas y mecánicas." },
  { id: "floors", label: "Pisos y niveles", hint: "Plataformas, colisión y tiles del mundo." },
  { id: "creatures", label: "Criaturas", hint: "Mobs, enemigos y bosses en arena." },
  { id: "gear", label: "Artículos y armas", hint: "Dummy de daño y pickup de equipo." },
  { id: "mechanics", label: "Mecánicas", hint: "Agarrar, tirar, inventario, ataque y roll." },
  { id: "buffs", label: "Buffs y debuffs", hint: "Haste, escudo, veneno y más." },
  { id: "drops", label: "Drop rates", hint: "Loot, rareza y probabilidad." },
];

export function modeToTestFlags(mode) {
  const on = { floors: true, creatures: true, gear: true, mechanics: true, buffs: true, drops: true };
  if (mode === "all") return on;
  return {
    floors: true,
    creatures: mode === "creatures",
    gear: mode === "gear",
    mechanics: mode === "mechanics" || mode === "all",
    buffs: mode === "buffs",
    drops: mode === "drops",
  };
}

export function spriteTexKey(s) {
  if (!s?.name) return "";
  return String(s.name).replace(/\s+/g, "_");
}

export function proceduralSprite(prompt = "sprite", size = 32) {
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext("2d");
  let h = 2166136261;
  for (let i = 0; i < prompt.length; i++) h = Math.imul(h ^ prompt.charCodeAt(i), 16777619);
  const hue = Math.abs(h) % 360;
  const color = (hh, l = 50) => `hsl(${(hue + hh + 360) % 360} 70% ${l}%)`;
  const rnd = (n) => {
    h = Math.imul(h ^ (h >>> 13), 1274126177);
    return Math.abs(h) % n;
  };
  const p = (x, y, c) => {
    ctx.fillStyle = c;
    ctx.fillRect(x, y, 1, 1);
  };
  const cx = Math.floor(size / 2);
  const head = Math.max(2, Math.floor(size * 0.18));
  const bodyW = Math.max(3, Math.floor(size * 0.28));
  const bodyH = Math.max(4, Math.floor(size * 0.38));
  const low = prompt.toLowerCase();
  const isItem = /arma|sword|potion|item|escudo|armor/.test(low);
  const isTile = /tile|terreno|mapa|suelo|grass|dirt/.test(low);
  if (isTile) {
    for (let y = 0; y < size; y++) {
      for (let x = 0; x < size; x++) {
        p(x, y, color(rnd(40) - 20, 28 + rnd(18)));
      }
    }
  } else if (isItem) {
    for (let y = 4; y < size - 4; y++) {
      for (let x = cx - 2; x <= cx + 2; x++) p(x, y, color(20, 55));
    }
    for (let x = cx - 5; x <= cx + 5; x++) p(x, 6, color(0, 70));
  } else {
    for (let y = 3; y < 3 + head; y++) {
      for (let x = cx - Math.floor(head / 2); x <= cx + Math.floor(head / 2); x++) p(x, y, color(0, 72));
    }
    for (let y = 3 + head; y < 3 + head + bodyH; y++) {
      for (let x = cx - Math.floor(bodyW / 2); x <= cx + Math.floor(bodyW / 2); x++) p(x, y, color(40, 48));
    }
    for (let i = 0; i < 6; i++) p(cx - 3 + rnd(7), 3 + head + bodyH + rnd(4), color(200, 35));
  }
  return canvas.toDataURL("image/png");
}

export const CODE_TEMPLATES = {
  python: {
    "src/player.py": `class Jugador:
    def __init__(self, x, y):
        self.x, self.y = x, y
        self.hp = 100
        self.velocidad = 4
        self.dano = 12
        self.defensa = 4

    def mover(self, dx, dy):
        self.x += dx * self.velocidad
        self.y += dy * self.velocidad
`,
    "src/combat.py": `def ttk(hp, dano, defensa, cooldown=0.4):
    """Tiempo para matar en segundos."""
    dps = max(1, dano - defensa) / cooldown
    return round(hp / dps, 2)
`,
  },
  javascript: {
    "src/mechanics.js": `// E agarrar · F tirar · J atacar · Shift roll · Q usar · 1-5 slot
window.GC_INV_MAX = 5;
window.GC_ON_PICKUP = function (item) {};
window.GC_ON_THROW = function (item) {};
window.GC_ON_ATTACK = function (hit) {};
window.GC_ON_ROLL = function () {};
window.GC_ON_USE = function (item) {};
`,
    "src/player.js": `export class Player {
  constructor(x, y) {
    this.x = x; this.y = y;
    this.hp = 100; this.speed = 4;
    this.damage = 12; this.defense = 4;
    this.inventario = [];
    this.slot = 0;
  }
  move(dx, dy) {
    this.x += dx * this.speed;
    this.y += dy * this.speed;
  }
  agarrar(item) {
    if (this.inventario.length >= 5) return false;
    this.inventario.push(item);
    return true;
  }
  tirar() {
    return this.inventario.splice(this.slot, 1)[0] || null;
  }
  atacar() {
    const arma = this.inventario.some((x) => x.kind === "weapon");
    return arma ? 12 : 6;
  }
  roll() { return true; }
}
`,
  },
  gdscript: {
    "scripts/Player.gd": `extends CharacterBody2D
@export var speed := 160.0
@export var jump_force := -320.0
func _physics_process(delta):
    var dir := Input.get_axis("ui_left", "ui_right")
    velocity.x = dir * speed
    if is_on_floor() and Input.is_action_just_pressed("ui_accept"):
        velocity.y = jump_force
    move_and_slide()
`,
  },
  csharp: {
    "Assets/Scripts/Player.cs": `using UnityEngine;
public class Player : MonoBehaviour {
    public float speed = 4f;
    void Update() {
        var dir = new Vector2(Input.GetAxisRaw("Horizontal"), Input.GetAxisRaw("Vertical"));
        transform.Translate(dir.normalized * speed * Time.deltaTime);
    }
}
`,
  },
};

export function statusColor(id) {
  return STATUS_MAP[id]?.color || "#94a3b8";
}

export function flattenEntities(project) {
  const entities = project?.entities || {};
  const out = [];
  Object.entries(entities).forEach(([kind, list]) => {
    (list || []).forEach((e) => out.push({ ...e, kind }));
  });
  return out;
}

export function patchEntity(entities, id, patch) {
  const next = { ...entities };
  Object.entries(next).forEach(([kind, list]) => {
    const i = (list || []).findIndex((e) => e.id === id);
    if (i >= 0) next[kind] = list.map((e, j) => (j === i ? { ...e, ...patch } : e));
  });
  return next;
}

export function addEntityLink(entities, fromId, toId, role = "related") {
  if (!fromId || !toId || fromId === toId) return entities;
  const flat = flattenEntities({ entities });
  const from = flat.find((e) => e.id === fromId);
  const to = flat.find((e) => e.id === toId);
  if (!from || !to) return entities;
  let next = entities;
  next = patchEntity(next, fromId, {
    links: [...(from.links || []).filter((l) => l.id !== toId), { id: toId, role, name: to.name, kind: to.kind }],
  });
  next = patchEntity(next, toId, {
    links: [...(to.links || []).filter((l) => l.id !== fromId), { id: fromId, role, name: from.name, kind: from.kind }],
  });
  return next;
}

export function removeEntityLink(entities, fromId, toId) {
  const flat = flattenEntities({ entities });
  const from = flat.find((e) => e.id === fromId);
  const to = flat.find((e) => e.id === toId);
  if (!from) return entities;
  let next = patchEntity(entities, fromId, { links: (from.links || []).filter((l) => l.id !== toId) });
  if (to) next = patchEntity(next, toId, { links: (to.links || []).filter((l) => l.id !== fromId) });
  return next;
}

export function allTags(project) {
  const tags = new Set(project?.tags || []);
  flattenEntities(project).forEach((e) => (e.tags || []).forEach((t) => tags.add(t)));
  (project?.story_items || []).forEach((s) => (s.tags || []).forEach((t) => tags.add(t)));
  (project?.kanban?.columns || []).forEach((c) =>
    (c.cards || []).forEach((card) => (card.tags || []).forEach((t) => tags.add(t)))
  );
  return [...tags].filter(Boolean);
}

export function computeProgress(project) {
  const items = flattenEntities(project);
  const stories = project?.story_items || [];
  const cards = (project?.kanban?.columns || []).flatMap((c) => c.cards || []);
  const total = items.length + stories.length + cards.length;
  if (!total) return 0;
  const done =
    items.filter((e) => e.status === "approved").length +
    stories.filter((s) => s.status === "approved").length +
    (project?.kanban?.columns?.find((c) => c.id === "done")?.cards?.length || 0);
  return Math.min(100, Math.round((done / total) * 100));
}

export function statusBreakdown(project) {
  const counts = { approved: 0, thinking: 0, review: 0, cut: 0, neutral: 0 };
  flattenEntities(project).forEach((e) => {
    const k = counts[e.status] !== undefined ? e.status : "neutral";
    counts[k] += 1;
  });
  return counts;
}

export function ttk(hp, dmg, def, cooldown = 0.4) {
  const net = Math.max(1, Number(dmg || 0) - Number(def || 0) * 0.35);
  const dps = net / Math.max(0.08, Number(cooldown) || 0.4);
  return round2((Number(hp) || 1) / dps);
}

function round2(n) {
  return Math.round(n * 100) / 100;
}

export const DEFAULT_SOUNDBOARD = [
  { id: "jump", label: "Jump", mode: "synth", f: 520, type: "square", t: 0.12, tag: "jump" },
  { id: "hit", label: "Hit", mode: "synth", f: 90, type: "sawtooth", t: 0.18, tag: "hit" },
  { id: "pickup", label: "Pickup", mode: "synth", f: 880, type: "square", t: 0.16, tag: "pickup" },
  { id: "throw", label: "Throw", mode: "synth", f: 240, type: "sawtooth", t: 0.14, tag: "throw" },
  { id: "roll", label: "Roll", mode: "synth", f: 200, type: "triangle", t: 0.2, tag: "roll" },
  { id: "use", label: "Use", mode: "synth", f: 330, type: "square", t: 0.18, tag: "use" },
  { id: "hurt", label: "Hurt", mode: "synth", f: 140, type: "square", t: 0.2, tag: "hurt" },
  { id: "ui", label: "UI", mode: "synth", f: 720, type: "sine", t: 0.08, tag: "ui" },
];

function starterEntity(patch) {
  return {
    id: crypto.randomUUID(),
    name: "",
    role: "",
    notes: "",
    status: "approved",
    tags: ["starter"],
    subcategory: "",
    subtype: "",
    hp: 100,
    damage: 10,
    defense: 4,
    speed: 4,
    attachments: [],
    ...patch,
  };
}

export function buildStarterKit() {
  const demo = buildDemoSprites();
  const { sprites, hero: heroSpr, slime: slimeSpr, sword: swordSpr, potion: potionSpr, animations } = demo;
  const hero = starterEntity({ name: "Héroe", role: "Jugador", subtype: "hero", hp: 100, damage: 12, defense: 5, speed: 5, notes: "MC de demo con walk cycle. WASD + salto.", linked_sprite_id: heroSpr.id });
  const slime = starterEntity({ name: "Slime", role: "Enemigo de prueba", subtype: "mob", hp: 28, damage: 6, defense: 1, speed: 2, notes: "Enemigo animado para playtest y TTK.", linked_sprite_id: slimeSpr.id });
  const sword = starterEntity({ name: "Espada rota", role: "Arma inicial", subtype: "longsword", hp: 1, damage: 12, defense: 0, notes: "Arma de demo. Visible en HUD y dummy del motor.", linked_sprite_id: swordSpr.id });
  const potion = starterEntity({ name: "Poción", role: "Consumible", subtype: "potion", hp: 20, damage: 0, defense: 0, notes: "Objeto de demo / drop.", linked_sprite_id: potionSpr.id });
  const chapter = {
    id: crypto.randomUUID(),
    type: "chapter",
    name: "Despertar en la mazmorra",
    body: "El héroe despierta en un piso de piedra. Un slime patrulla el pasillo.",
    status: "thinking",
    tags: ["starter", "tutorial"],
    subcategory: "",
    attachments: [],
  };
  const mission = {
    id: crypto.randomUUID(),
    type: "mission",
    name: "Derrota al slime",
    body: "Valida daño, drops y plataformas en el Motor.",
    status: "approved",
    tags: ["playtest"],
    subcategory: "",
    attachments: [],
  };
  const objective = {
    id: crypto.randomUUID(),
    type: "objective",
    name: "Salir de la sala",
    body: "Comprueba colisión de pisos y salto.",
    status: "neutral",
    tags: ["world"],
    subcategory: "",
    attachments: [],
  };
  const card = (title, tags, status) => ({ id: crypto.randomUUID(), title, tags, status });
  return {
    sprites,
    entities: {
      characters: [hero],
      npcs: [],
      mobs: [slime],
      enemies: [],
      minibosses: [],
      bosses: [],
      items: [potion],
      articles: [],
      weapons: [sword],
      armor: [],
    },
    story_items: [chapter, mission, objective],
    kanban: {
      columns: [
        { id: "todo", title: "Por Hacer", cards: [card("Probar el motor con Héroe vs Slime", ["playtest"], "thinking"), card("Ajustar drop rate de la espada", ["balance"], "neutral")] },
        { id: "doing", title: "En Progreso", cards: [card("Definir el primer nivel (piso de piedra)", ["world"], "approved")] },
        { id: "done", title: "Hecho", cards: [card("Kit de prueba 2D creado", ["starter"], "approved")] },
      ],
    },
    soundboard: DEFAULT_SOUNDBOARD.map((p) => ({ ...p, id: crypto.randomUUID() })),
    hud: defaultHud("rpg"),
    gdd: {
      idea: "Un platformer 2D de demo: héroe animado vs slime, con arma, poción y HUD.",
      objective: "Cruzar la sala, recoger la espada y derrotar al slime.",
      story: "Despertar en la mazmorra. Tutorial de movimiento y combate.",
      goals: ["Probar el motor", "Ajustar TTK del slime", "Definir el primer tileset"],
      secrets: [],
      notes: "Kit inicial. Edita o borra lo que no uses.",
    },
    diagram: {
      nodes: [
        { id: `characters-${hero.id}`, type: "entity", position: { x: 40, y: 40 }, data: { kind: "characters", label: hero.name, tags: hero.tags, entityId: hero.id } },
        { id: `mobs-${slime.id}`, type: "entity", position: { x: 280, y: 40 }, data: { kind: "mobs", label: slime.name, tags: slime.tags, entityId: slime.id } },
        { id: `weapons-${sword.id}`, type: "entity", position: { x: 520, y: 40 }, data: { kind: "weapons", label: sword.name, tags: sword.tags, entityId: sword.id } },
        { id: `story-${chapter.id}`, type: "entity", position: { x: 40, y: 200 }, data: { kind: "story", label: chapter.name, tags: chapter.tags, entityId: chapter.id } },
      ],
      edges: [{ id: "e-hero-slime", source: `characters-${hero.id}`, target: `mobs-${slime.id}`, animated: true }],
    },
    animations,
    tags: ["starter", "playtest"],
  };
}

/** Reemplaza solo el kit de demo (sprites/anims/soundboard/HUD starter). No borra ideas propias. */
export function replaceDemoKit(project) {
  const kit = buildStarterKit();
  const keptSprites = (project.sprites || []).filter((s) => s.role !== "starter");
  const keptAnims = (project.animations || []).filter((a) => !(a.name || "").match(/Héroe caminar|Slime bounce/i));
  const nextEntities = { ...(project.entities || {}) };
  const mergeKind = (kind, kitList) => {
    const existing = nextEntities[kind] || [];
    const withoutStarter = existing.filter((e) => !(e.tags || []).includes("starter"));
    nextEntities[kind] = [...kitList, ...withoutStarter];
  };
  mergeKind("characters", kit.entities.characters);
  mergeKind("mobs", kit.entities.mobs);
  mergeKind("items", kit.entities.items);
  mergeKind("weapons", kit.entities.weapons);
  return {
    sprites: [...kit.sprites, ...keptSprites],
    animations: [...kit.animations, ...keptAnims],
    soundboard: kit.soundboard,
    entities: nextEntities,
    config: {
      ...(project.config || {}),
      starter_kit: true,
      hud: kit.hud,
      language: "javascript",
    },
    gdd: {
      ...(project.gdd || {}),
      idea: project.gdd?.idea || kit.gdd.idea,
      objective: project.gdd?.objective || kit.gdd.objective,
    },
  };
}

export function ensureProjectDefaults(project) {
  if (!project) return project;
  const modules = project.idea_modules?.length ? project.idea_modules : DEFAULT_MODULES;
  let entities = { ...Object.fromEntries(DEFAULT_MODULES.map((m) => [m.id, []])), ...(project.entities || {}) };
  let story_items = project.story_items;
  if (!Array.isArray(story_items)) {
    const gdd = project.gdd || {};
    const migrated = [];
    if (gdd.story) migrated.push(makeItem("chapter", "Historia principal", gdd.story, "thinking"));
    (gdd.goals || []).forEach((g, i) => migrated.push(makeItem("objective", `Objetivo ${i + 1}`, g, "neutral")));
    (gdd.secrets || []).forEach((g, i) => migrated.push(makeItem("secret", `Secreto ${i + 1}`, g, "thinking")));
    story_items = migrated;
  }
  const emptyEntities = Object.values(entities).every((l) => !(l || []).length);
  const emptyStory = !Array.isArray(story_items) || story_items.length === 0;
  const emptySprites = !(project.sprites || []).length;
  const emptyKanban = !(project.kanban?.columns || []).some((c) => (c.cards || []).length);
  const needsKit = !project.config?.starter_kit && emptySprites && emptyEntities;
  const kit = needsKit ? buildStarterKit() : null;
  if (kit) {
    entities = { ...entities, ...kit.entities };
    story_items = emptyStory ? kit.story_items : story_items;
  }
  return {
    ...project,
    mode: "2d",
    idea_modules: modules,
    entities,
    story_items,
    sprites: emptySprites && kit ? kit.sprites : (project.sprites || []),
    kanban: emptyKanban && kit ? kit.kanban : (project.kanban?.columns ? project.kanban : DEFAULT_KANBAN),
    diagram: (!(project.diagram?.nodes || []).length && kit) ? kit.diagram : (project.diagram || { nodes: [], edges: [] }),
    animations: (!(project.animations || []).length && kit) ? kit.animations : (project.animations || []),
    soundboard: (project.soundboard && project.soundboard.length) ? project.soundboard : (kit ? kit.soundboard : DEFAULT_SOUNDBOARD.map((p) => ({ ...p }))),
    gdd: (() => {
      const fromProj = project.gdd || {};
      const fromKit = kit?.gdd || {};
      return {
        idea: fromProj.idea || fromKit.idea || "",
        objective: fromProj.objective || fromKit.objective || "",
        story: fromProj.story || fromKit.story || "",
        goals: (fromProj.goals || []).length ? fromProj.goals : (fromKit.goals || []),
        secrets: fromProj.secrets || fromKit.secrets || [],
        notes: fromProj.notes || fromKit.notes || "",
      };
    })(),
    activity: project.activity || [],
    tags: (project.tags || []).length ? project.tags : (kit?.tags || []),
    config: {
      resolution: "1920x1080",
      visual_style: "Pixel Art",
      language: "javascript",
      fps: 60,
      platform: "PC / Web",
      camera: "side",
      theme_apply: { ...DEFAULT_THEME_APPLY },
      scenes: DEFAULT_SCENES.map((s) => ({ ...s })),
      milestones: DEFAULT_MILESTONES.map((s) => ({ ...s })),
      ship: DEFAULT_SHIP.map((s) => ({ ...s })),
      playtest_log: [],
      scope_frozen: false,
      budget: { enemies: 4, bosses: 1, sfx: 12 },
      ...(project.config || {}),
      hud: project.config?.hud || kit?.hud || defaultHud("rpg"),
      ...(kit ? { starter_kit: true } : {}),
    },
    samples: project.samples || [],
    references: project.references || [],
    notes: Array.isArray(project.notes) ? project.notes : [],
  };
}

function makeItem(type, name, body, status) {
  return {
    id: crypto.randomUUID(),
    type,
    name,
    body,
    status,
    tags: [],
    subcategory: "",
  };
}

export function newEntity(patch = {}) {
  return {
    id: crypto.randomUUID(),
    name: "",
    role: "",
    stats: "",
    notes: "",
    status: "neutral",
    tags: [],
    subcategory: "",
    subtype: "",
    linked_sprite_id: "",
    linked_file_id: "",
    linked_audio_id: "",
    hp: 100,
    damage: 10,
    defense: 4,
    speed: 4,
    attachments: [],
    attrs: {},
    links: [],
    ...patch,
  };
}

export const NOTE_LINK_TYPES = [
  { id: "module", label: "Módulo" },
  { id: "entity", label: "Idea / entidad" },
  { id: "class", label: "Clase / subtipo" },
  { id: "sprite", label: "Sprite" },
  { id: "audio", label: "Audio" },
  { id: "file", label: "Código" },
  { id: "story", label: "Historia" },
  { id: "engine", label: "Motor" },
];

export function newStudioNote(patch = {}) {
  const now = new Date().toISOString();
  return {
    id: crypto.randomUUID(),
    title: "",
    body: "",
    category: "idea",
    links: [],
    created_at: now,
    updated_at: now,
    ...patch,
  };
}

export function projectCoachSnapshot(project) {
  const ents = flattenEntities(project);
  const sprites = project?.sprites || [];
  const audioN = (project?.soundboard || []).length + (project?.samples || []).length;
  return {
    name: project?.name || "",
    genre: project?.genre || "",
    camera: project?.config?.camera || "side",
    idea: project?.gdd?.idea || "",
    objective: project?.gdd?.objective || "",
    modules: (project?.idea_modules || []).filter((m) => m.enabled !== false).map((m) => m.name || m.id),
    entities: ents.slice(0, 40).map((e) => ({
      name: e.name, kind: e.kind, subtype: e.subtype || "", hp: e.hp,
      notes: String(e.notes || "").slice(0, 100),
    })),
    sprites: sprites.slice(0, 24).map((s) => ({ name: s.name, type: s.type, subtype: s.subtype || "" })),
    files: (project?.files || []).map((f) => f.path).slice(0, 20),
    stories: (project?.story_items || []).slice(0, 12).map((s) => s.name),
    notes: (project?.notes || []).slice(0, 12).map((n) => n.title),
    audio_count: audioN,
    missing: {
      hero: !ents.some((e) => e.subtype === "hero" || e.kind === "characters"),
      enemy: !ents.some((e) => ["mobs", "enemies", "minibosses", "bosses"].includes(e.kind)),
      weapon: !ents.some((e) => e.kind === "weapons"),
      sprites: sprites.length === 0,
      audio: audioN === 0,
      playtest: !(project?.config?.playtest_log || []).length,
    },
  };
}

export function newStoryItem(patch = {}) {
  return {
    id: crypto.randomUUID(),
    type: "chapter",
    name: "",
    body: "",
    status: "neutral",
    tags: [],
    subcategory: "",
    attachments: [],
    ...patch,
  };
}

export function describePatch(patch) {
  const key = Object.keys(patch || {})[0];
  const map = {
    entities: "Actualizó ideas y entidades",
    sprites: "Cambió sprites",
    files: "Editó código",
    story_items: "Actualizó la historia",
    kanban: "Movió tareas del kanban",
    soundtracks: "Guardó audio",
    soundboard: "Editó el soundboard",
    gdd: "Editó el GDD",
    config: "Ajustó la configuración",
    animations: "Editó animaciones",
    diagram: "Actualizó el canvas",
  };
  return map[key] || "Guardó cambios";
}

export function readAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}

export function readAsText(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsText(file);
  });
}

export function downloadDataUrl(dataUrl, filename) {
  const a = document.createElement("a");
  a.href = dataUrl;
  a.download = filename;
  a.click();
}

export function downloadText(text, filename, mime = "text/plain") {
  const blob = new Blob([text], { type: mime });
  const url = URL.createObjectURL(blob);
  downloadDataUrl(url, filename);
  setTimeout(() => URL.revokeObjectURL(url), 1500);
}

export function cropImage(dataUrl, rect) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const c = document.createElement("canvas");
      c.width = Math.max(1, Math.round(rect.w));
      c.height = Math.max(1, Math.round(rect.h));
      const ctx = c.getContext("2d");
      ctx.imageSmoothingEnabled = false;
      ctx.drawImage(img, rect.x, rect.y, rect.w, rect.h, 0, 0, c.width, c.height);
      resolve(c.toDataURL("image/png"));
    };
    img.src = dataUrl;
  });
}

export function extractPalette(dataUrl, max = 8) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const c = document.createElement("canvas");
      const size = 32;
      c.width = size;
      c.height = size;
      const ctx = c.getContext("2d");
      ctx.drawImage(img, 0, 0, size, size);
      const data = ctx.getImageData(0, 0, size, size).data;
      const map = new Map();
      for (let i = 0; i < data.length; i += 4) {
        if (data[i + 3] < 40) continue;
        const key = `${Math.round(data[i] / 16) * 16},${Math.round(data[i + 1] / 16) * 16},${Math.round(data[i + 2] / 16) * 16}`;
        map.set(key, (map.get(key) || 0) + 1);
      }
      const colors = [...map.entries()]
        .sort((a, b) => b[1] - a[1])
        .slice(0, max)
        .map(([k]) => {
          const [r, g, b] = k.split(",").map(Number);
          return `#${[r, g, b].map((n) => n.toString(16).padStart(2, "0")).join("")}`;
        });
      resolve(colors);
    };
    img.src = dataUrl;
  });
}

export function languageFromPath(path) {
  if (!path) return "plaintext";
  if (path.endsWith(".js")) return "javascript";
  if (path.endsWith(".ts")) return "typescript";
  if (path.endsWith(".py")) return "python";
  if (path.endsWith(".md")) return "markdown";
  if (path.endsWith(".json")) return "json";
  if (path.endsWith(".html")) return "html";
  if (path.endsWith(".css")) return "css";
  if (path.endsWith(".cs")) return "csharp";
  if (path.endsWith(".gd")) return "plaintext";
  if (path.endsWith(".lua")) return "lua";
  return "plaintext";
}

export const SPRITE_SEARCH_INTENTS = [
  { id: "sketch", label: "Bocetos & refs", extra: "concept art sketch reference" },
  { id: "pixel", label: "Pixel / sprite", extra: "pixel art sprite transparent background" },
  { id: "sheet", label: "Sheets & frames", extra: "sprite sheet animation frames walk cycle idle" },
];

export const SPRITE_SEARCH_STYLES = [
  { id: "any", label: "Cualquier pixel" },
  { id: "8bit", label: "8-bit" },
  { id: "16bit", label: "16-bit" },
  { id: "lpc", label: "LPC / RPG" },
  { id: "topdown", label: "Top-down" },
  { id: "side", label: "Side-scroller" },
];

export function guessSheetLayout(w, h) {
  const width = Number(w) || 1;
  const height = Number(h) || 1;
  const sizes = [16, 24, 32, 48, 64, 96, 128];
  for (const s of sizes) {
    if (width % s === 0 && height % s === 0) {
      const cols = width / s;
      const rows = height / s;
      const n = cols * rows;
      if (n >= 2 && n <= 64) return { frameW: s, frameH: s, cols, rows };
    }
  }
  if (width > height && width % height === 0) {
    return { frameW: height, frameH: height, cols: width / height, rows: 1 };
  }
  if (height > width && height % width === 0) {
    return { frameW: width, frameH: width, cols: 1, rows: height / width };
  }
  const s = Math.min(32, width, height);
  return {
    frameW: s,
    frameH: s,
    cols: Math.max(1, Math.floor(width / s)),
    rows: Math.max(1, Math.floor(height / s)),
  };
}

export function sliceSpriteSheet(dataUrl, { cols, rows, maxFrames = 48 } = {}) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const cCount = Math.max(1, Number(cols) || 1);
      const rCount = Math.max(1, Number(rows) || 1);
      const fw = Math.max(1, Math.floor(img.width / cCount));
      const fh = Math.max(1, Math.floor(img.height / rCount));
      const frames = [];
      for (let y = 0; y < rCount; y++) {
        for (let x = 0; x < cCount; x++) {
          if (frames.length >= maxFrames) break;
          const c = document.createElement("canvas");
          c.width = fw;
          c.height = fh;
          const ctx = c.getContext("2d");
          ctx.imageSmoothingEnabled = false;
          ctx.drawImage(img, x * fw, y * fh, fw, fh, 0, 0, fw, fh);
          const data = ctx.getImageData(0, 0, fw, fh).data;
          let visible = 0;
          for (let i = 3; i < data.length; i += 4) if (data[i] > 16) visible += 1;
          if (visible < 6) continue;
          frames.push({
            data_url: c.toDataURL("image/png"),
            w: fw,
            h: fh,
            col: x,
            row: y,
          });
        }
      }
      resolve({ frames, frameW: fw, frameH: fh, cols: cCount, rows: rCount, width: img.width, height: img.height });
    };
    img.onerror = () => reject(new Error("No se pudo leer el sheet"));
    img.src = dataUrl;
  });
}

export function isImageFrame(frame) {
  return Boolean(frame && typeof frame === "object" && !Array.isArray(frame) && frame.data_url);
}
